// @ts-nocheck
// TODO 因为相关方法，在主应用中维护，并且挂载在window上面，这里先做个转换，后续再考虑详细方案
var panshiClass = /** @class */ (function () {
    function panshiClass() {
    }
    Object.defineProperty(panshiClass.prototype, "server", {
        get: function () {
            var _a;
            if ((_a = window.__PMS_CONSOLE__) === null || _a === void 0 ? void 0 : _a.server) {
                return window.__PMS_CONSOLE__.server;
            }
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(panshiClass.prototype, "request", {
        get: function () {
            var _a;
            if ((_a = window.__PMS_CONSOLE__) === null || _a === void 0 ? void 0 : _a.request) {
                return window.__PMS_CONSOLE__.request;
            }
            return function () { };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(panshiClass.prototype, "user", {
        get: function () {
            var _a;
            if ((_a = window.__PMS_CONSOLE__) === null || _a === void 0 ? void 0 : _a.user) {
                return window.__PMS_CONSOLE__.user;
            }
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(panshiClass.prototype, "primary", {
        get: function () {
            var _a;
            if ((_a = window.__PMS_CONSOLE__) === null || _a === void 0 ? void 0 : _a.primary) {
                return window.__PMS_CONSOLE__.primary;
            }
            return '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(panshiClass.prototype, "file", {
        get: function () {
            var _a;
            if ((_a = window.__PMS_CONSOLE__) === null || _a === void 0 ? void 0 : _a.file) {
                return window.__PMS_CONSOLE__.file;
            }
            return {
                upload: function () { },
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(panshiClass.prototype, "dictionary", {
        get: function () {
            var _a;
            if ((_a = window.__PMS_CONSOLE__) === null || _a === void 0 ? void 0 : _a.dictionary) {
                return window.__PMS_CONSOLE__.dictionary;
            }
            return {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(panshiClass.prototype, "Organization", {
        get: function () {
            var _a;
            if ((_a = window.__PMS_CONSOLE__) === null || _a === void 0 ? void 0 : _a.Organization) {
                return window.__PMS_CONSOLE__.Organization;
            }
            return {};
        },
        enumerable: false,
        configurable: true
    });
    return panshiClass;
}());
var panshi = new panshiClass();
export { panshi };
//# sourceMappingURL=index.js.map